import { render } from "./ProLaboreForm.vue?vue&type=template&id=aa66b3f8&scoped=true"
import script from "./ProLaboreForm.vue?vue&type=script&lang=js"
export * from "./ProLaboreForm.vue?vue&type=script&lang=js"

import "./ProLaboreForm.vue?vue&type=style&index=0&id=aa66b3f8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa66b3f8"]])

export default __exports__